import React from "react";
import "../css/Viewpage.css";
import logo from "../images/logo.jpeg";
import { useNavigate, useLocation } from "react-router-dom";

function PrivacyPolicy() {
    const navigation = useNavigate();
    const location = useLocation();

    const isFromRegistration = location.state?.isFromRegistration;

    // Home button
    const handleHomeClick = () => {
        if (isFromRegistration) {
            return;
        }

        navigation("/Viewpage");
    };

    // Back button from registration
    const handleBackClick = () => {
        navigation("/", { replace: true });
    };

    // Disable right click
    const disableRightClick = (e) => {
        e.preventDefault();
    };

    return (
        <div
            className="privacy-policy-page"
            onContextMenu={disableRightClick}
        >
            {/* ================= HEADER ================= */}
            <header className="top-bar shadow-sm">
                <div className="container">
                    <div className="privacy-header">

                        {isFromRegistration ? (
                            /* -------- BACK BUTTON -------- */
                            <button
                                type="button"
                                className="privacy-back-btn"
                                onClick={handleBackClick}
                            >
                                <i className="bi bi-arrow-left me-2"></i>
                                Back
                            </button>
                        ) : (
                            /* -------- LOGO + HOME -------- */
                            <>
                                <img
                                    src={logo}
                                    alt="IndiaMetti Logo"
                                    className="privacy-logo"
                                    onClick={handleHomeClick}
                                />

                                <button
                                    type="button"
                                    className="privacy-home-btn"
                                    onClick={handleHomeClick}
                                >
                                    <i className="bi bi-house me-1"></i>
                                    Home
                                </button>
                            </>
                        )}

                    </div>
                </div>
            </header>

            {/* ================= PRIVACY CONTENT ================= */}
            <main className="privacy-policy-content center">
                <div className="privacy-policy-container">

                    <h1 className="privacy-title">
                        Privacy Policy
                    </h1>

                    <p className="privacy-updated">
                        Last Updated: May 2026
                    </p>

                    {/* 1. Introduction */}
                    <section className="privacy-section">
                        <h4>1. Introduction</h4>

                        <p>
                            Welcome to IndiaMetti. We are committed to protecting
                            your personal information and your right to privacy.
                            This Privacy Policy explains how we collect, use,
                            disclose, and safeguard your information when you
                            use our website and services.
                        </p>
                    </section>

                    {/* 2. Information We Collect */}
                    <section className="privacy-section">
                        <h4>2. Information We Collect</h4>

                        <p>
                            In order to provide our matrimony services, we
                            collect several types of information:
                        </p>

                        <ul>
                            <li>
                                <strong>Personal Profile Data:</strong>{" "}
                                Name, gender, date of birth, religion, caste,
                                mother tongue, photos, and physical attributes.
                            </li>

                            <li>
                                <strong>Contact Information:</strong>{" "}
                                Email address and mobile number.
                            </li>

                            <li>
                                <strong>Professional Details:</strong>{" "}
                                Education, occupation, and annual income.
                            </li>

                            <li>
                                <strong>Identity Verification:</strong>{" "}
                                Documents uploaded for profile verification
                                purposes.
                            </li>

                            <li>
                                <strong>Activity Data:</strong>{" "}
                                Information about your interests, shortlists,
                                and profiles you have viewed.
                            </li>
                        </ul>
                    </section>

                    {/* 3. How We Use Your Information */}
                    <section className="privacy-section">
                        <h4>3. How We Use Your Information</h4>

                        <p>
                            We use the collected data for the following purposes:
                        </p>

                        <ul>
                            <li>
                                To create and manage your account and profile.
                            </li>

                            <li>
                                To suggest relevant matches based on your
                                preferences.
                            </li>

                            <li>
                                To verify the authenticity of users on our
                                platform.
                            </li>

                            <li>
                                To facilitate communication between interested
                                parties.
                            </li>

                            <li>
                                To improve our services and user experience.
                            </li>
                        </ul>
                    </section>

                    {/* 4. Sharing Your Information */}
                    <section className="privacy-section">
                        <h4>4. Sharing Your Information</h4>

                        <p>
                            <strong>With other users:</strong>{" "}
                            Your profile information, excluding private contact
                            details, may be visible to other registered users
                            of IndiaMetti to help you find suitable matches.
                        </p>

                        <p>
                            <strong>Third-party service providers:</strong>{" "}
                            We may share data with trusted partners who help us
                            with technical operations, payment processing, or
                            verification services.
                        </p>

                        <p>
                            <strong>Legal requirements:</strong>{" "}
                            We may disclose information if required by law or
                            when necessary to protect the safety and rights of
                            our users.
                        </p>
                    </section>

                    {/* 5. Data Security */}
                    <section className="privacy-section">
                        <h4>5. Data Security</h4>

                        <p>
                            We implement a variety of security measures,
                            including encryption and secure socket layers, to
                            maintain the safety of your personal information.
                            However, no method of transmission over the
                            Internet is 100% secure, and we cannot guarantee
                            absolute security.
                        </p>
                    </section>

                    {/* 6. Your Rights and Choices */}
                    <section className="privacy-section">
                        <h4>6. Your Rights and Choices</h4>

                        <p>
                            You have the right to:
                        </p>

                        <ul>
                            <li>
                                Access and update your profile information at
                                any time via the "Edit Profile" section.
                            </li>

                            <li>
                                Delete your account permanently through the
                                Settings menu.
                            </li>

                            <li>
                                Control who can see your photos through privacy
                                settings.
                            </li>

                            <li>
                                Opt out of marketing communications.
                            </li>
                        </ul>
                    </section>

                    {/* 7. Cookies */}
                    <section className="privacy-section">
                        <h4>7. Cookies</h4>

                        <p>
                            We use cookies to enhance your experience, gather
                            general visitor information, and track visits to
                            our website. You can choose to turn off cookies
                            through your browser settings.
                        </p>
                    </section>

                    {/* 8. Changes to This Policy */}
                    <section className="privacy-section">
                        <h4>8. Changes to This Policy</h4>

                        <p>
                            We may update our Privacy Policy from time to time.
                            We will notify you of any changes by posting the new
                            Privacy Policy on this page and updating the
                            "Last Updated" date.
                        </p>
                    </section>

                    {/* 9. Contact Us */}
                    <section className="privacy-section">
                        <h4>9. Contact Us</h4>

                        <p>
                            If you have any questions about this Privacy Policy,
                            please contact us at:
                        </p>

                        <div className="privacy-contact-card">
                            <p>
                                <strong>Email:</strong>{" "}
                                support@indiametti.com
                            </p>

                            <p>
                                <strong>Phone:</strong>{" "}
                                +91 72007 45891
                            </p>
                        </div>
                    </section>

                </div>
            </main>

            {/* ================= FOOTER ================= */}
            <footer className="privacy-footer">
                <label>
                    Copyright © 2026 NavGraph Technologies. All Rights Reserved.
                </label>
            </footer>
        </div>
    );
}

export default PrivacyPolicy;